import { Component, Inject, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import { MusicsDataService } from '../../providers/Table/musicsData.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-cover-search',
  templateUrl: './coverSearch.component.html',
  styleUrls: ['./coverSearch.component.scss']
})
export class CoverSearchComponent implements OnInit, AfterViewInit {

  discogsResults: any[] = [];

  filteredDiscogsResults: any[] = [];

  defaultRecords: any = 10;

  pageEvent: any;

  loading = false;

  dataOut = {
    startRow: 0,
    endRow: 0,
    cover: '',
    edit: false,
    year: '',
    album: ''
  };

  @ViewChild('searchInput') searchInput;

  constructor(private musicsDataService: MusicsDataService,
              private iconRegistry: MatIconRegistry,
              private sanitizer: DomSanitizer,
              @Inject(MAT_DIALOG_DATA) private dataIn,
              private dialogRef: MatDialogRef<any>) {
    iconRegistry.addSvgIcon('close', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/close.svg'));
  }

  ngOnInit() {
    this.dataOut.startRow = this.dataIn.startRow;
    this.dataOut.endRow = this.dataIn.endRow;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.searchInput.nativeElement.value = this.dataIn.search;
      this.discogsSearchCover(this.dataIn.search);
    });
  }

  discogsSearchCover(search) {
    this.discogsResults = [];
    this.filteredDiscogsResults = [];
    if (search && search.length > 0) {
      this.loading = true;
      this.musicsDataService.discogsSearchCover(search)
        .then(res => {
          this.loading = false;
          this.discogsResults = res;
          this.filteredDiscogsResults = this.discogsResults.slice(0, this.defaultRecords);
        })
        .catch(() => {
          this.loading = false;
          this.discogsResults = [];
          this.filteredDiscogsResults = [];
        });
    }
  }

  discogsSearchCoverEnter(e, search) {
    e.preventDefault();
    this.discogsSearchCover(search);
  }

  selectCover(url, year, title) {
    this.dataOut.edit = true;
    this.dataOut.cover = url;
    this.dataOut.year = year;
    this.dataOut.album = title.match(/[^-]*-(.*)/)?.[1]?.trim() || title;
    this.dialogRef.close(this.dataOut);
  }

  onPaginateChange(data) {
    this.filteredDiscogsResults = this.discogsResults.slice(data.pageIndex * data.pageSize, (data.pageIndex + 1) * data.pageSize);
  }

}
